import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsConstants } from '../../../../shared/constants/Analytics';
import { ErrorFormatter } from '../../../../shared/formatter/error.formatter';
import { SendEmailContactInput } from '../../../../shared/models/lead/sendMail.input';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { TrackAnalyticsService } from '../../../../shared/services/track-analytics/track-analytics.service';
import { UserService } from '../../../../shared/services/user/user.service';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';

export abstract class EmailSenderComponent implements OnInit {
    emailContactInput: SendEmailContactInput;

    get f(): any {
        return this.form.controls;
    }
    form: FormGroup;
    editorConfig: AngularEditorConfig;
    emailMessage: string;
    subject: string;
    leadId: string;
    respond: boolean;
    receiver: boolean;
    contactName: any;
    sending = false;
    constructor(
        protected readonly formBuilder: FormBuilder,
        protected readonly translateService: TranslatorService,
        protected readonly userLogged: AuthService,
        protected readonly userService: UserService,
        protected readonly spinner: NgxSpinnerService,
        protected readonly leadService: LeadService,
        protected readonly trackAnalytics: TrackAnalyticsService,
        protected readonly leadComuService: LeadsComunicationService,
        protected readonly toasterService: ToastService,
        protected readonly errorFormatter: ErrorFormatter,
    ) {
        this.editorConfig = {
            editable: true,
            spellcheck: false,
            sanitize: false,
            height: '15rem',
            minHeight: '5rem',
            placeholder: `${this.translateService.trans('modals.send_mail.write_your_email')}...`
        };
        this.emailMessage = '';
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            subject: ['', Validators.required],
            body: ['', Validators.required]
        });

    }

    sendMail(): void {
        this.spinner.show();
        if (this.form.invalid) {
            this.spinner.hide();

            return;
        }

        this.bindForm();

        this.emailContactInput = new SendEmailContactInput();
        this.emailContactInput.emailContact = {
            body: this.emailMessage,
            leadId: this.leadId,
            subject: this.subject,
            respond: this.respond,
            receiver: this.receiver
        };

        this.send();

    }

    abstract send();

    bindForm(): void {
        this.subject = this.f.subject.value;
        this.emailMessage = this.f.body.value;
    }

    resetForm(): void {
        this.form.reset();
        this.emailMessage = '';
        this.subject = '';
        this.receiver = true;
    }

    abstract handlerEmailSended();

    protected getSignMail() {
        this.userService.getSignMail$().subscribe((sign: string) => {
            this.emailMessage += sign ? `<br/><br/><br/><br/>${sign}` : this.getGrettings();
            this.form = this.formBuilder.group({
                subject: [this.subject, Validators.required],
                body: [this.emailMessage, Validators.required]
            });
        });
    }

    protected getGrettings(): string {
        return `<br/><br/><br/><br/>Atentamente,<br/>
          ${this.userLogged.getUser().name} ${this.userLogged.getUser().lastName}`;
    }

    protected emailSendedHandler = () => {
        this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_CONTACT, AnalyticsConstants.EVENT_EMAIL);
        this.sending = true;

        this.handlerEmailSended();

        this.leadComuService.launchReloadMyLead(this.emailContactInput.emailContact.leadId);
        this.resetForm();
        this.toasterService
            // TODO translate
            .showToast(
                'success',
                this.translateService.trans('toaster.email_sent'),
                `${this.translateService.trans('toaster.email_sent.message')} ${this.contactName}`
            );
        this.spinner.hide();
        this.sending = false;
    }

    protected emailErrorHandler = (error) => {
        this.toasterService
            .showToast(
                'error',
                this.translateService.trans('toaster.email.error'),
                this.errorFormatter.formatErrors(error.graphQLErrors)
            );
        this.spinner.hide();
        this.sending = false;

    }

}
